// CategoryPicker — 6 locked categories + custom label (W3.1 §5.3 step 4).
//
// Renders the 6 categories as FilterChipGroup chips. When 「其他」(custom)
// is selected, a label input appears (required, 1-30 chars per BR-02).

import { useId } from "react";

import { FilterChipGroup } from "@/components/primitives/FilterChipGroup";
import {
  ANNIVERSARY_CATEGORIES,
  categoryLabelZh,
  isAnniversaryCategory,
} from "@/lib/anniversary/categoryIcon";
import { cn } from "@/lib/utils/cn";

export interface CategoryPickerProps {
  value: string;
  customLabel: string;
  onCategoryChange: (next: string) => void;
  onCustomLabelChange: (next: string) => void;
  disabled?: boolean;
  className?: string;
}

const VISIBLE_CATEGORIES = ANNIVERSARY_CATEGORIES.filter((c) => c !== "personal");

export function CategoryPicker({
  value,
  customLabel,
  onCategoryChange,
  onCustomLabelChange,
  disabled = false,
  className,
}: CategoryPickerProps) {
  const customId = useId();
  const isCustom = value === "custom";
  const safeValue = isAnniversaryCategory(value) ? value : "";

  return (
    <div className={cn("flex flex-col gap-3", className)} data-component="CategoryPicker">
      <FilterChipGroup
        items={VISIBLE_CATEGORIES.map((c) => ({
          id: c,
          label: categoryLabelZh(c),
        }))}
        selectedId={safeValue}
        onSelect={(id) => onCategoryChange(id)}
        accent="you"
        ariaLabel="選擇分類"
      />
      {isCustom ? (
        <div className="flex flex-col gap-1.5">
          <label htmlFor={customId} className="font-label text-ink-2">
            自訂分類標籤 (必填)
          </label>
          <input
            id={customId}
            type="text"
            maxLength={30}
            value={customLabel}
            onChange={(e) => onCustomLabelChange(e.target.value)}
            disabled={disabled}
            placeholder="例: 第一次約會"
            data-testid="category-custom-label"
            className="h-12 rounded-md border border-hairline bg-paper px-3 text-ink-1 focus-visible:outline focus-visible:outline-2 focus-visible:outline-you-strong focus-visible:outline-offset-2"
          />
        </div>
      ) : null}
    </div>
  );
}